import { render, staticRenderFns } from "./StickySections.vue?vue&type=template&id=64e851a4&scoped=true&"
import script from "./StickySections.vue?vue&type=script&lang=js&"
export * from "./StickySections.vue?vue&type=script&lang=js&"
import style0 from "./StickySections.vue?vue&type=style&index=0&id=64e851a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e851a4",
  null
  
)

export default component.exports